module.exports = __webpack_public_path__ + "media/images/products/template/01/05-5f2518801fc1295129217a966c7096bf.jpg";